var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"help-content-container",class:[_vm.classes]},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}}),(_vm.relatedTopics!=null)?_c('related-topics',{attrs:{"topics":_vm.relatedTopics}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }